import * as util from "./util"
import { rgba } from "polished"
import styled from "@emotion/styled"
import * as animations from "./animations"
import * as colors from "./colors"

export const verticalSpacing = (attr = "padding-top", multiple = 1) => `
	${util.responsiveStyles(
    attr,
    100 * multiple,
    90 * multiple,
    80 * multiple,
    44 * multiple
  )}
`

export const baseBorderRadius = 4
export const cardBorderRadius = "var(--card-border-radius)"

// Buttons, Inputs, Selects, etc.
export const uiElementSizes = {
  tiny: 26,
  small: 34,
  medium: 46,
  large: 50,
  extraLarge: 70,
}

export const responsiveUiSizes = {
  small: 1,
  medium: 1,
  large: 1,
  huge: 1.2,
}

export const shadow = () => `0 2px 6px ${rgba(colors.textColor, 0.15)}`

export const shadowLift = () => `0 4px 10px ${rgba(colors.textColor, 0.25)}`

export const shadowSoft = () => `0 2px 6px ${rgba(colors.textColor, 0.05)}`

export const marketoInputShadow = shadowPercent =>
  `0 3px 8px rgba(0, 0, 0, ${shadowPercent})`

export const Card = styled.div`
  border-radius: ${cardBorderRadius};
  box-shadow: ${shadow};
  color: inherit;
  border: none;
  outline: none;
  transition: background ${animations.mediumSpeed} ease-in-out,
    color ${animations.mediumSpeed} ease-in-out,
    border ${animations.mediumSpeed} ease-in-out,
    box-shadow ${animations.mediumSpeed} ease-in-out,
    transform ${animations.mediumSpeed} ease-in-out,
    opacity ${animations.mediumSpeed} ease-in-out,
    mix-blend-mode ${animations.mediumSpeed} ease-in-out;
`
